
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/pageSettingsPanel/settings/tabs/PageSettingsPermissionsTab/PermissionsTabComponents/permissionsThumbnails.scss.css.virtualfile';
        module.exports = {"root":"_root_142c0_1"};